import { render, staticRenderFns } from "./clientSprint.vue?vue&type=template&id=1fba5b90&scoped=true&"
import script from "./clientSprint.vue?vue&type=script&lang=js&"
export * from "./clientSprint.vue?vue&type=script&lang=js&"
import style0 from "./clientSprint.vue?vue&type=style&index=0&id=1fba5b90&scoped=true&lang=css&"
import style1 from "./clientSprint.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fba5b90",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oeze/Documents/grupa/grupa-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1fba5b90')) {
      api.createRecord('1fba5b90', component.options)
    } else {
      api.reload('1fba5b90', component.options)
    }
    module.hot.accept("./clientSprint.vue?vue&type=template&id=1fba5b90&scoped=true&", function () {
      api.rerender('1fba5b90', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ClientDashboard/roadmap/clientSprint.vue"
export default component.exports